// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__GetArtist from "../api/subsonic/getArtist.jsx";

function make(artistId) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__GetArtist.make(artistId), {
      credentials: state.auth.credentials
    }), (function (response) {
      const artist_albumCount = response.albumCount;
      const artist_coverArt = response.coverArt;
      const artist_id = response.id;
      const artist_musicBrainzId = response.musicBrainzId;
      const artist_name = response.name;
      const artist_starred = response.starred;
      const artist_userRating = response.userRating;
      const artist = {
        albumCount: artist_albumCount,
        coverArt: artist_coverArt,
        id: artist_id,
        musicBrainzId: artist_musicBrainzId,
        name: artist_name,
        starred: artist_starred,
        userRating: artist_userRating
      };
      const state = store.getState();
      const arg = [];
      const albums = (function (param) {
        return Stdlib__Option.value(param, arg);
      })(response.album);
      const albumBaseById = MergeIntoMap.mergeIntoMap(state.albums.baseById, albums, (function (x) {
        return x.id;
      }));
      const albumIdsByArtistId = MergeIntoMap.mergeIntoMap(state.artists.albumIdsByArtistId, [albums.map(function (x) {
          return x.id;
        })], (function (param) {
        return response.id;
      }));
      const byId = MergeIntoMap.mergeIntoMap(state.artists.byId, [artist], (function (x) {
        return x.id;
      }));
      if (albumBaseById !== state.albums.baseById || albumIdsByArtistId !== state.artists.albumIdsByArtistId || byId !== state.artists.byId) {
        store.setState(function (prevState) {
          const init = prevState.albums;
          const init$1 = prevState.artists;
          return {
            albums: {
              baseById: albumBaseById,
              detailsById: init.detailsById,
              infoById: init.infoById,
              songIdsById: init.songIdsById
            },
            artists: {
              albumIdsByArtistId: albumIdsByArtistId,
              artistInfoById: init$1.artistInfoById,
              byId: byId,
              listIds: init$1.listIds,
              similarArtistsById: init$1.similarArtistsById,
              topSongIdsByArtistName: init$1.topSongIdsByArtistName
            },
            auth: prevState.auth,
            player: prevState.player,
            songs: prevState.songs
          };
        });
      }
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* MergeIntoMap Not a pure module */
